import aiService from '@/services/ai';

const state = {
    isLoading: false,
    isReady: false,
    loadProgress: 0,
    error: null,
    autoLoadStarted: false
};

const mutations = {
    SET_STATE(state, payload) {
        Object.assign(state, payload);
    },
    SET_AUTO_LOAD_STARTED(state, value) {
        state.autoLoadStarted = value;
    }
};

const actions = {
    init({ commit }) {
        aiService.subscribe(aiState => {
            commit('SET_STATE', aiState);
        });
    },

    async loadModel({ commit, state }) {
        if (state.autoLoadStarted) return;
        commit('SET_AUTO_LOAD_STARTED', true);

        try {
            await aiService.loadModel();
        } catch (error) {
            console.error('Failed to load AI model:', error);
        }
    },

    async analyze({ state }, { data, promptType = 'generic', options = {} }) {
        if (!state.isReady) {
            throw new Error('AI model not ready');
        }

        const prompts = require('@/services/ai/prompts').default;
        const promptFn = prompts[promptType] || prompts.generic;

        return aiService.analyze(data, promptFn, options);
    }
};

const getters = {
    isReady: state => state.isReady,
    isLoading: state => state.isLoading,
    loadProgress: state => state.loadProgress,
    error: state => state.error
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
